export const initializeNewsArticles = () => {
  const blocks = document.querySelectorAll('[data-component="news-articles"]')

  blocks.forEach(block => {
    const perPage = parseInt(block.dataset.perPage, 10) || 9
    const cards = Array.from(block.querySelectorAll('[data-component="news-articles-card"]'))
    const filterButtons = block.querySelectorAll('[data-component="news-articles-filter"]')
    const searchInput = block.querySelector('[data-component="news-articles-search"]')
    const searchButton = block.querySelector('[data-component="news-articles-search-button"]')
    const loadMoreButton = block.querySelector('[data-component="news-articles-load-more"]')
    const loadMoreWrap = block.querySelector('[data-component="news-articles-load-more-wrap"]')
    const emptyMessage = block.querySelector('[data-component="news-articles-empty"]')

    let activeTopic = ''
    let searchTerm = ''
    let shownCount = perPage

    const matchesFilters = card => {
      const topics = (card.dataset.topics || '').split(',').filter(Boolean)
      const search = card.dataset.search || ''
      const topicMatch = !activeTopic || topics.includes(activeTopic)
      const searchMatch = !searchTerm || search.includes(searchTerm)
      return topicMatch && searchMatch
    }

    const render = () => {
      const matched = cards.filter(matchesFilters)

      cards.forEach(card => {
        const index = matched.indexOf(card)
        card.classList.toggle('hidden', index === -1 || index >= shownCount)
      })

      if (emptyMessage) {
        emptyMessage.classList.toggle('hidden', matched.length > 0)
      }

      if (loadMoreWrap) {
        loadMoreWrap.classList.toggle('hidden', shownCount >= matched.length)
      }
    }

    filterButtons.forEach(button => {
      button.addEventListener('click', () => {
        activeTopic = button.dataset.topic || ''
        shownCount = perPage

        filterButtons.forEach(btn => {
          btn.dataset.active = btn === button ? 'true' : 'false'
        })

        render()
      })
    })

    const runSearch = () => {
      searchTerm = (searchInput?.value || '').trim().toLowerCase()
      shownCount = perPage
      render()
    }

    if (searchInput) {
      searchInput.addEventListener('input', runSearch)
      searchInput.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault()
          runSearch()
        }
      })
    }

    if (searchButton) {
      searchButton.addEventListener('click', event => {
        event.preventDefault()
        runSearch()
      })
    }

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        shownCount += perPage
        render()
      })
    }

    render()
  })
}
